// extracted by mini-css-extract-plugin
module.exports = {"videoOverlay":"VideoModal_videoOverlay__a3Fcz","videoContent":"VideoModal_videoContent__gSY_A","closeButton":"VideoModal_closeButton__Bv5dc"};